// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, func, number, object, oneOfType, string } from 'prop-types'
import ReactTooltip from 'react-tooltip'

class GenericTooltipWrapper extends React.Component {
  static propTypes = {
    tooltipColumn: string,
    TooltipComponent: func,
    tooltipData: oneOfType([
      array,
      object,
      string,
      number,
    ]),
    tooltipId: string.isRequired,
  }

  // returns the assigned tooltip component for the tooltip container
  getTooltipComponent = () => {
    const {
      tooltipColumn,
      TooltipComponent,
      tooltipData,
      tooltipId,
    } = this.props

    // if the tooltip component wasn't properly mapped via the parent's columns prop,
    // render a wanrning.
    // NOTE - this is only to aide in development and should never be visible in prod
    return (
      TooltipComponent
        ? (
          <TooltipComponent
            idRoot={`${tooltipId}-${tooltipColumn}-`}
            tooltipData={tooltipData} />
        ) : (
          <this.unmappedTooltipComponent />
        )
    )
  }

  // just in case the columns prop has a tooltipContainer and yet a
  // column which was not mapped in columns triggers the shared tooltip,
  // display this as a warning message.
  unmappedTooltipComponent = () => (
    <div
      className={'bg-red text-white padding-half'}
      style={{ width: '220px' }}>
      {`Warning! The ${this.props.tooltipColumn} column has triggered an unmapped tooltip!`}
    </div>
  )

  render () {
    const {
      getTooltipComponent,
      props: { tooltipId },
    } = this

    return (
      <ReactTooltip
        delayHide={200}
        effect={'solid'}
        id={tooltipId}
        getContent={getTooltipComponent}
        place={'bottom'}
        type={'light'} />
    )
  }
}

export default GenericTooltipWrapper
